import axios from "axios";
import { toast } from "react-toastify";
import paths from "routes/paths"; // 👈 Import
import { hideLoader, showLoader } from "./loaderManager";
import { baseUrl } from "./baseUrl";

export const apiInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

// Request interceptor
apiInstance.interceptors.request.use(
  (config) => {
    showLoader(); // 👈 Start showing loader
    const bearerToken = localStorage.getItem("bearerToken");
    if (bearerToken) {
      config.headers.Authorization = `Bearer ${bearerToken}`;
    }
    return config;
  },
  (error) => {
    hideLoader(); // 👈 Hide loader on request error
    return Promise.reject(error);
  }
);

// Response interceptor
apiInstance.interceptors.response.use(
  (response) => {
    hideLoader(); // 👈 Hide loader after success
    return response;
  },
  (error) => {
    hideLoader(); // 👈 Hide loader after failure

    const expectedError =
      error.response?.status >= 400 && error.response?.status < 500;
    const errorMessage =
      error.response?.data?.message || "An unexpected error occurred";

    if (!navigator.onLine) {
      toast.error("Network error - please check your internet connection");
      return Promise.reject({ message: "Network Error" });
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = paths.login;
    }

    return Promise.reject(errorMessage);
  }
);

export default apiInstance;
